import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1af94c96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progressplaninfo-container" }
const _hoisted_2 = { class: "top-container" }
const _hoisted_3 = { class: "top1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务名称：", -1))
const _hoisted_5 = { style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_6 = { class: "top2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "计划开始时间：", -1))
const _hoisted_8 = { class: "top3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "计划完成时间", -1))
const _hoisted_10 = { class: "top4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "实际完成时间：", -1))
const _hoisted_12 = { class: "top5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "审批状态：", -1))
const _hoisted_14 = { style: {
            color: '#E02020',
          } }
const _hoisted_15 = { class: "top6" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "逾期天数：", -1))
const _hoisted_17 = { class: "top7" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "工期：")
], -1))
const _hoisted_19 = { class: "bottom-container" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center-container" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "责任人：", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "责任单位：", -1))
const _hoisted_23 = { class: "button" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("查看逾期子任务")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.progressDetail.name ? _ctx.progressDetail.name : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.startPlan
              ? _ctx.progressDetail.startPlan.substr(0, 10)
              : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.endPlan ? _ctx.progressDetail.endPlan.substr(0, 10) : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.endReal ? _ctx.progressDetail.endReal.substr(0, 10) : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.approveStatusFilter(_ctx.progressDetail.status)), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.overdueDays ? _ctx.progressDetail.overdueDays : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.progressDetail.duration
                ? _ctx.progressDetail.duration
                : ""), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", null, [
        _hoisted_21,
        _createElementVNode("span", null, _toDisplayString(_ctx.progressDetail.createName
            ? _ctx.progressDetail.createName
            : ""), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_22,
        _createElementVNode("span", null, _toDisplayString(_ctx.progressDetail.responsibleDepartment
            ? _ctx.progressDetail.responsibleDepartment
            : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_van_button, {
          block: "",
          type: "primary",
          onClick: _ctx.showTask
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}